export default __webpack_public_path__ + "static/media/miguel-lopes-37.b8afa805.jpg";